export const getRoundedMax = (input: number, roundStep = 5) => {
  const padded = Math.round(input + input * 0.25);
  return !(padded % roundStep) ? padded : padded + (roundStep - (padded % roundStep));
};
